// show the extra row containing the values as they are in the uploaded file
$(document).on("click", ".admin_rate_files tr.result-line", function (event) {
  event.currentTarget.nextElementSibling.toggleAttribute("hidden");
});

// enable the submit button when there is a file selected
$(document).on("change", "#rate_file_import_file", function (event) {
  const form = event.target.form;
  if (event.target.files.length > 0 && form.id != "new_rate_file") {
    form.elements.namedItem("commit").toggleAttribute("disabled");
  }
});
